import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, config } from 'rxjs';
import { ConfigService } from '../../../../shared/services/config.service';
import { UserService } from '../../../../shared/services/user.service';
import { IRouteParams } from '../../../../shared/route-params';
import { DocumentStatus } from '../models/document-status.model';

@Injectable({
  providedIn: 'root'
})
export class DocumentAdminService {

  constructor(private http: HttpClient, private configService: ConfigService, private userService: UserService) { }

  //#976 BEA 2021-01-08 to force reading from localstorage each (and every) time
  private get httpOptions() {
    return {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'APIKEY': 'ams-direct-api-document-key',
        'SessionId': this.userService.sessionId
      })
    };
  }

  getLanguages(addNoCategory = false): Observable<any> {
    return this.http.get<any>(this.configService.config.documentUrl + `/api/DocumentAdmin/GetLanguages`, this.httpOptions);
  }

  getDocumentTypes(): Observable<any> {
    return this.http.get<any>(this.configService.config.documentUrl + `/api/DocumentAdmin/GetDocumentTypes`, this.httpOptions);
  }

  removeDocumentType(id: number): Observable<any> {
    return this.http.get<any>(this.configService.config.documentUrl + `/api/DocumentAdmin/DeleteDocumentType?id=${id}`, this.httpOptions);
  }

  addOrUpdateDocumentType(data: any): Observable<any> {
    return this.http.post<any>(this.configService.config.documentUrl + '/api/DocumentAdmin/UpdateDocumentType', data, this.httpOptions);
  }


  //Attributes:
  getAttributes(): Observable<any> {
    return this.http.get<any>(this.configService.config.documentUrl + `/api/DocumentAdmin/GetDocumentAttributes`, this.httpOptions);
  }

  addOrUpdateAttribute(data: any): Observable<any> {
    return this.http.post<any>(this.configService.config.documentUrl + '/api/DocumentAdmin/UpdateDocumentAttribute', data, this.httpOptions);
  }

  removeAttribute(id: number): Observable<any> {
    return this.http.get<any>(this.configService.config.documentUrl + `/api/DocumentAdmin/DeleteDocumentAttribute?id=${id}`, this.httpOptions);
  }

  //Statuses
  getStatuses(): Observable<DocumentStatus[]> {
    return this.http.get<DocumentStatus[]>(this.configService.config.documentUrl + `/api/DocumentAdmin/GetDocumentStatuses`, this.httpOptions);
  }

  //DocumentTags:
  getTags(): Observable<any> {
    return this.http.get<any>(this.configService.config.documentUrl + `/api/DocumentAdmin/GetDocumentTags`, this.httpOptions);
  }

  addOrUpdateTag(data: any): Observable<any> {
    return this.http.post<any>(this.configService.config.documentUrl + '/api/DocumentAdmin/UpdateDocumentTag', data, this.httpOptions);
  }

  removeDocumentTag(id: number): Observable<any> {
    return this.http.get<any>(this.configService.config.documentUrl + `/api/DocumentAdmin/DeleteDocumentTag?id=${id}`, this.httpOptions);
  }

  //DocumentCode
  getCodes(): Observable<any> {
    return this.http.get<any>(this.configService.config.documentUrl + `/api/DocumentAdmin/GetDocumentCodes`, this.httpOptions);
  }

  addOrUpdateCode(data: any): Observable<any> {
    return this.http.post<any>(this.configService.config.documentUrl + '/api/DocumentAdmin/UpdateDocumentCode', data, this.httpOptions);
  }

  removeCode(id: number): Observable<any> {
    return this.http.get<any>(this.configService.config.documentUrl + `/api/DocumentAdmin/DeleteDocumentCode?id=${id}`, this.httpOptions);
  }
}

